import { RouteType } from '../router/routes';

export const currentRoute = (pathname: string, routes: RouteType[]) => {
  return routes.find((el) => el.path === pathname);
};
